import _ from 'lodash'

export const extractVenue = suggestion => {
  // build object of address components using the first component of each type
  const addressComponents = {}
  suggestion.gmaps.address_components.forEach(component => {
    component.types.forEach(type => {
      if (!addressComponents[type]) {
        addressComponents[type] = component.long_name
      }
    })
  })

  // return the venue object using address components
  return {
    name: addressComponents.premise || addressComponents.establishment || addressComponents.point_of_interest || '',
    address1: _.trim(`${addressComponents.street_number || ''} ${addressComponents.route || ''}`) || '',
    address2: '',
    city: addressComponents.locality || addressComponents.political || addressComponents.postal_town || '',
    postal_code: addressComponents.postal_code || null,
    latitude: suggestion.location && suggestion.location.lat || null,
    longitude: suggestion.location && suggestion.location.lng || null,
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/geosuggest/geosuggest.js
 **/